// utils/deliverySlots.js

export const formatTimeRangeIST = (startTime, endTime) => {
    const formatTime = (time) => {
        const [h, m] = time.split(':')
        const hour = Number(h)
        const minutes = m || '00'
        const displayHour = hour % 12 || 12
        return `${displayHour}:${minutes}`
    }

    const getMeridiem = (time) => {
        const hour = Number(time.split(':')[0])
        return hour >= 12 ? 'PM' : 'AM'
    }

    const startFormatted = formatTime(startTime)
    const endFormatted = formatTime(endTime)
    const meridiem = getMeridiem(endTime)

    return `${startFormatted} - ${endFormatted} ${meridiem}`
}

const DAYS = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
]

export const getDayLabelFromBackend = (dayOfWeek,holiday) => {
    const today = new Date()
    const todayBackendIndex = (today.getDay() + 6) % 7
    // JS: Sunday=0 → convert to Monday=0

    if (dayOfWeek === todayBackendIndex) return 'Today'
    if (dayOfWeek === (todayBackendIndex + 1) % 7) return 'Tomorrow'

    return DAYS[dayOfWeek]
}

export const getTodayBackendDay = () => {
    const jsDay = new Date().getDay() // 0=Sunday
    return (jsDay + 6) % 7            // 0=Monday
}

export const isSlotPastCutoff = (slot, dayOfWeek) => {
    if (!slot || !slot.start_time) {
        return false
    }
    
    const now = new Date();
    const todayBackendDay = getTodayBackendDay();
    
    // Only apply cutoff logic for today's slots
    if (dayOfWeek === todayBackendDay) {
        const [startHour, startMin] = slot.start_time.split(':').map(Number);
        const slotStartTime = new Date();
        slotStartTime.setHours(startHour, startMin, 0, 0);

        const cutoffMinutes = Number(slot.cutoff_minutes_before || 0)

        if (cutoffMinutes > 0) {
            // Calculate cutoff time (start_time - cutoff_minutes_before)
            const cutoffTime = new Date(slotStartTime.getTime() - cutoffMinutes * 60 * 1000);
            // Check if current time is past cutoff time
            return now > cutoffTime;
        }

        // When cutoff is 0 (or not set), close the slot once its actual start time is reached
        return now >= slotStartTime;
    }
    
    // For future days, cutoff doesn't apply (booking is allowed)
    return false;
}

